import { OccConfig } from '@spartacus/core';

export const modifyMotorsOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        getIframeModiFyMotors: '/users/${userId}/launchConfigurator',
      } as any,
    },
  },
};
